import React from 'react';
export function PainPoints() {
  return <section className="py-20 bg-[#FFFBF4]" data-id="element-244">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E3A5F] mb-6" data-id="element-247">
            Si sos maestra de primaria, esto te va a sonar muy conocido…
          </h2>
          <div className="bg-white p-8 rounded-2xl shadow-md border border-amber-100 text-left max-w-3xl mx-auto" data-id="element-248">
            <p className="text-lg text-slate-700 mb-4 font-medium" data-id="element-249">
              Son las 10 de la noche del domingo.
            </p>
            <p className="text-lg text-slate-700 mb-4" data-id="element-250">
              Mañana tenés clase y todavía no preparaste el bloque de Lengua.
            </p>
            <p className="text-lg text-slate-700 mb-4" data-id="element-251">
              Abrís el celular. Buscás en grupos de WhatsApp. Revisás drives
              ajenos. Adaptás algo que más o menos sirve. Imprimís sobre la
              marcha.
            </p>
            <p className="text-lg text-slate-700 font-medium italic text-[#1E3A5F]" data-id="element-252">
              Y te dormís tarde con esa sensación que ya conocés demasiado bien:
              <br data-id="element-253" />
              <span className="text-xl font-bold mt-2 block" data-id="element-254">
                "Espero que alcance para mañana."
              </span>
            </p>
          </div>
        </div>

        <div className="mb-16" data-id="element-255">
          <p className="text-xl text-center text-slate-700 font-medium mb-10" data-id="element-256">
            El problema no es tu dedicación.
            <br data-id="element-257" />
            <span className="font-bold text-[#1E3A5F]" data-id="element-258">
              El problema es que estás sosteniendo todo sola. Sin un sistema que
              te sostenga a vos.
            </span>
          </p>
          <p className="text-lg text-center text-slate-600 mb-12" data-id="element-259">
            Y eso genera tres cosas que agotan a muchísimas maestras argentinas:
          </p>

          <div className="space-y-8" data-id="element-260">
            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-261">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-262">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-263">
                  1
                </span>
                Los domingos que dejaron de ser tuyos
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-264">
                Deberían ser de tu familia. De descanso. De recarga.
              </p>
              <p className="text-slate-700 text-lg mb-2" data-id="element-265">
                Pero en cambio los pasás buscando textos, cortando y pegando
                material ajeno que nunca termina de cerrar del todo.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-266">
                Y llegás al lunes cansada antes de empezar.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-267">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-268">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-269">
                  2
                </span>
                La presión constante de no tener nada escrito
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-270">
                El papá de un alumno te pregunta en la reunión:{' '}
                <span className="italic font-medium" data-id="element-271">"¿Cómo lee mi hijo?"</span>
              </p>
              <p className="text-slate-700 text-lg mb-2" data-id="element-272">
                Vos sabés la respuesta. La tenés en la cabeza. Pero no tenés
                nada concreto para mostrarle.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-273">
                Y la directora pide la planificación anual de Lengua para el
                jueves… y empezás de cero otra vez.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-274">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-275">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-276">
                  3
                </span>
                La cabeza que no se apaga
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-277">
                Terminás el día y seguís pensando en las lecturas de mañana, los
                materiales que faltan, las actividades que hay que preparar.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-278">
                Porque cada semana implica volver a inventar todo otra vez desde
                cero.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center bg-[#1E3A5F] text-white p-10 rounded-3xl shadow-xl" data-id="element-279">
          <p className="text-2xl md:text-3xl font-bold leading-relaxed" data-id="element-280">
            Las maestras no se cansan de enseñar.
            <br data-id="element-281" />
            <span className="text-[#FCD34D]" data-id="element-282">
              Se cansan de tener que improvisar todo solas, cada semana, sin
              parar.
            </span>
          </p>
        </div>
      </div>
    </section>;
}